import { render } from "./DownloadButton.vue?vue&type=template&id=3f9329e1&scoped=true"
import script from "./DownloadButton.vue?vue&type=script&lang=js"
export * from "./DownloadButton.vue?vue&type=script&lang=js"

import "./DownloadButton.vue?vue&type=style&index=0&id=3f9329e1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f9329e1"]])

export default __exports__